<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.4591 19.3887L5.27246 20.9616L6.34389 26.25H19.201L20.2725 20.9616L17.0858 19.3887C16.2942 20.9485 14.66 22.0192 12.7725 22.0192C10.8849 22.0192 9.25067 20.9485 8.4591 19.3887Z"
      class="fill-current"
    />
    <path
      d="M17.0582 16.7308C17.0582 19.0673 15.1394 20.9615 12.7725 20.9615C10.4055 20.9615 8.48675 19.0673 8.48675 16.7308C8.48675 14.3942 10.4055 12.5 12.7725 12.5C15.1394 12.5 17.0582 14.3942 17.0582 16.7308Z"
      class="fill-current"
    />
    <path d="M22.7725 13.75H35.2725V15.625H22.7725V13.75Z" class="fill-current" />
    <path d="M22.7725 17.5H35.2725V19.375H22.7725V17.5Z" class="fill-current" />
    <path d="M22.7725 21.25H29.0225V23.125H22.7725V21.25Z" class="fill-current" />
  </svg>
</template>
